<script>
    /*

    	ReferralSections.svelte

        Contains multiple "hard coded" <ReferralSection> components.
        Need to iterate the API data structure for sections and questions.

        This is where the required field checks are as well.

    */

    import { onMount } from 'svelte';
    import {setErrorAlert, setWarningAlert} from '../../stores/AlertsStore';
    import { OBJECT, MULTI_CHOICE } from './question-types.js';

    // TCARE components
    import ReferralSection from './ReferralSection.svelte';
    import {AccountStore} from "../../common/account";
    import {addSavedServices} from "../../api/services";
    import {ID, SERVICE_NAME} from "../../common/constants";

    // SMUI components

    $: expandedSectionId = 'send-referral';
    $: currentSection = lookupCurrentSection(expandedSectionId);

    export let store;
    export let sections;                // fetched via API call from host page
    export let setIsSubmitted;          // shows successScreen on page if API call is OK

    onMount(() => {
    })


    // this will change if all sections arrive in a structure
    // then we will access the section via the sectionId key
    const lookupCurrentSection = (id) => {
        if (!sections || !sections[id]) return null;
        return sections[id];
    }

    // iterates an array - not object props
    const lookupQuestion = (id) => {
        for (const question of currentSection.questions) {
            if (question.id === id) {
                return question;
            }
        }
        return null;
    }


    // this is how different sections are "opened" - set the current sectionId
    // also the required checks are here
    const setExpanded = (sectionId) => {
        let reqQuest = getFirstRequiredQuestion(currentSection);
        let reqProp = getFirstRequiredProp(currentSection);
        if (!reqQuest && !reqProp) {
            expandedSectionId = sectionId;      // OK to nav to new section
        } else {
            if (reqQuest) {
                showRequiredQuestionError(reqQuest);
            } else {
                showRequiredPropError(reqProp);
            }
        }
    }

    const showRequiredQuestionError = (question) => {
        const msg = 'Please answer "' + question.label + '"';
        setErrorAlert(msg, 2000);
    }

    const showRequiredPropError = (prop) => {
        const msg = 'Please complete the field "' + prop.label + '"';
        setErrorAlert(msg, 2000);
    }

    const onSaveResourceButtonClick = () => {
        onSaveResource();
    }

    const onSaveResource = async () => {
        if (!$AccountStore?.isLoggedIn) {
            return;
        }

        let serviceId = parseInt($store.apiData['service-id']); // json key for index object not db object
        if (isNaN(serviceId)) {
            return;
        }

        const json = await addSavedServices([serviceId]);          // services.ts - must pass array

        if (json.errors) {
            setWarningAlert('Error while saving resource', 2000);
        }
    }

    // make API call here! need required field check here too
    const submitReferral = () => {
        onSaveResourceButtonClick()
        prepareReferral();
        setIsSubmitted(true);
    }

    // prepare a lightweight structure to upload?
    // or just send back entire section object
    const prepareReferral = () => {
    }

    
    // 11/1 - ONLY CHECK "ACTIVE" REQUIRED FIELDS! (not required if hidden)

    // if parent question it must be matching
    const isActiveQuestion = (question) => {
        if (typeof question.depId === "undefined") return true;             // no "parent" question - ignore
        if (question.depId === null) return true;                           // no "parent" question - ignore

        let depQuestion = lookupQuestion(question.depId);
        if (depQuestion === null) return true;                             // "parent" question not found

        // from here on there IS a "parent" depQuestion

        // values can be false so do not just check falsey - check for !== null
        if (depQuestion.questionType === MULTI_CHOICE) {
            // value must be in the value array for checkbox types
            return depQuestion.value !== null ? depQuestion.value.includes(question.depValue) : false;
        } else {
            // just match the value for all other types
            return depQuestion.value !== null ? depQuestion.value === question.depValue : false;
        }
    }


    // must check .isRequired AND if its parent is visible (dependent)
    const isActiveRequiredQuestion = (question) => {
        if (!question.isRequired) return false;
        return isActiveQuestion(question);
    }

    const isActiveRequiredProp = (question, obj, propName) => {
        if (!obj[propName].isRequired) return false;
        return isActiveQuestion(question);
    }




    // 11/1 - THESE COULD PROBABLY BE MOVED TO ReferralSection

    // need to know the current section first
    // iterate all questions and return first isRequired with null or blank answer
    const getFirstRequiredQuestion = (section) => {
        if (!section) return null;
        for (const q of section.questions) {
            // if (q.isRequired) {
            if (isActiveRequiredQuestion(q)) {
                if (q.value === null) return q;
                if (Array.isArray(q.value) && q.value.length === 0) return q;
            }
        }
        return null;
    }

    // for OBJECT questionTypes - use 'in' not 'of'
    // must also check for empty strings, not just null
    // iterate all props and return first isRequired with null or blank answer
    const getFirstRequiredProp = (section) => {
        if (!section) return null;
        for (const q of section.questions) {
            if (q.questionType === OBJECT) {
                let obj = q.value;
                for (const propName in obj) {
                    // if (obj[propName].isRequired) {
                    if (isActiveRequiredProp(q, obj, propName)) {
                        if (obj[propName].value === null || obj[propName].value === '') return obj[propName];
                    }
                }
            }
        }
        return null;
    }


</script>

<style>
    .referral-sections {
        width: 97%;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: flex-end;
        /* border: 1px solid red; */
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<!-- TODO: read in the IPA data and iterate sections -->
<!-- TODO: would we get all the sections in a single API call? -->

<!-- submitReferral is only needed for final but passed to all -->
<!-- TODO: sections will eventually be retrieved via API calls -->
<div class="referral-sections">
    <!-- note the Svelte syntax here for iterating props -->
    {#each Object.entries(sections) as [key, value]}    
        <ReferralSection {expandedSectionId} {setExpanded} section={value} {submitReferral} />        
    {/each}
</div>
